import React, { useEffect } from "react";
import "./modern-cart-style.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> April 30, 2025</p>

      <h2>1. Information We Collect</h2>
      <p>
        We collect a variety of personal and technical information to provide our services and improve your experience.
        This includes your name, email address, phone number, payment method (processed securely through Stripe),
        and certain device identifiers such as IP address, browser type, operating system, and referring pages.
        We also collect behavioral data such as your interactions with our products, time spent on the site, and items added to your cart.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        The information we collect is used strictly to improve the quality and reliability of our service.
        We process your data to complete purchases, detect fraudulent transactions, ensure compliance with legal obligations,
        provide support, and personalize your experience on the platform. We may also aggregate anonymized data for analytics and internal reporting.
      </p>

      <h2>3. IP Address Collection</h2>
      <p>
        Your IP address is automatically collected when you interact with our website, particularly during the checkout process.
        This allows us to validate transactions, analyze traffic sources, implement regional compliance, and help detect fraudulent or suspicious activity.
        Under California privacy law (CCPA/CPRA), IP addresses are considered personal information and treated accordingly.
      </p>

      <h2>4. Use of Cookies</h2>
      <p>
        We use essential cookies to enhance your user experience, remember your shopping cart, and maintain your session for up to 24 hours.
        These cookies do not track you across other websites and are not used for advertising purposes.
        You can disable cookies through your browser settings, though doing so may limit core functionality such as cart persistence.
      </p>

      <h2>5. Third-Party Services</h2>
      <p>
        We rely on secure third-party providers such as Stripe for payment processing and may use analytics tools to understand
        user behavior and site performance. These services may collect anonymized technical information under their own privacy policies.
        We carefully select these vendors and ensure they adhere to data protection standards equivalent to our own.
      </p>

      <h2>6. Data Sharing and Disclosure</h2>
      <p>
        We do not sell your personal data. We only share your information with third parties when necessary to provide core services,
        such as processing payments, delivering support, hosting infrastructure, or complying with legal requirements.
        In rare circumstances, we may be compelled to disclose information if required by a subpoena, court order, or legal obligation.
      </p>

      <h2>7. Your Rights (California Residents)</h2>
      <p>
        If you reside in California, you have specific rights under the California Consumer Privacy Act (CCPA) and the California Privacy Rights Act (CPRA).
        These include the right to request details about what personal information we collect, the right to access and correct your data,
        and the right to request deletion of your information. We do not sell your personal data, so the "Do Not Sell My Information" provision is not applicable.
        To exercise any of these rights, you may contact us via the email address provided below.
      </p>

      <h2>8. Data Security</h2>
      <p>
        We take data security seriously. Our site uses HTTPS encryption, secure server hosting, and strong access controls.
        All sensitive transactions are processed through PCI-compliant payment providers (e.g., Stripe).
        While no system is completely immune to breaches, we follow industry best practices to minimize risk and maintain the confidentiality of your information.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We may periodically update this Privacy Policy to reflect new legal requirements, changes in our practices, or improvements in our services.
        Any changes will be posted on this page, and the effective date will be updated accordingly.
        We encourage you to review this policy from time to time to stay informed about how we protect your privacy.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or your personal data, please contact us at:
        <strong> connectedsports@gmail.com</strong>. We are committed to resolving complaints and ensuring transparency.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
